module.exports = __webpack_public_path__ + "static/mouse-4c78d62f51149ab9c78373ef7e8ea74c.svg";